import React, { useEffect } from 'react';
import FloatLabel from '../components/FloatLabel/floatLabel';
import { Button,  DatePicker, Input, message, notification, Select, Space, Spin, Table } from 'antd';
import Link from 'antd/es/typography/Link';
import CustomButton from '../components/Buttons/Button';
import { formatNumberWithCommas, formatToTwoDecimalPlaces, getUserRole, rejectedApiMessage } from '../utilities/CommonHelper';
import "../styles/oboDashboard.css";
import { useDispatch, useSelector } from 'react-redux';
import { fetchBuAndClientDetails_OBO } from '../store/reducers/orderDashboardSlice';
import moment from 'moment';
import { fetchOBOReport_AllOpportunities, fetchOBOReport_ChartData, getOboDownloadReport, setOBOFilterData } from '../store/reducers/oboDashboardSlice';
import type { InputRef, TableColumnsType, TablePaginationConfig } from 'antd';
import OboModalContainer from '../containers/OboModalContainer/oboModalContainer';
import { DownOutlined, RightOutlined, SearchOutlined } from '@ant-design/icons';
import OboChildOppDetailsTableContainer from '../containers/OboChildOppDetailsTableContainer/oboChildOppDetailsTableContainer';
import { ColumnType, FilterConfirmProps } from 'antd/es/table/interface';
import Highlighter from 'react-highlight-words';
import OboChartsContainer from '../containers/OboChartsContainer/oboChartsContainer';
import exportButton from '../assets/exportButton.svg';
import { getUserAccessData } from '../utilities/sessionHelper';

const { RangePicker } = DatePicker;
interface DataType  {
	key :React.Key;
	client: string
	opportunityID: string;
	opportunityName: string;
	sumOfTCV: string;
	revenue: string;
	obo: string;
	countOfSow: any;
	countOfChildOpp: any;
	
  }
  
type DataIndex = keyof DataType;

const OboDashboard: React.FC = () => {
	const dispatch = useDispatch();
	const oboReportData = useSelector((state: any) => state.oboReports);
	const orderDashboardData= useSelector((state: any) => state.orderDashboard);
    const [selectedClient, setSelectedClient] = React.useState<any>([]);
    const [clientList, setClientList] = React.useState<any>([]);
    const [buList, setBuList] = React.useState<any>([]);
    const [selectedBu, setSelectedBu] = React.useState<any>([]);
	const [oboModalVisible,setoboModalVisible] = React.useState<boolean>(false);
	const [selectedopp, setSelectedOpp] = React.useState<any>({});
	const [dateRange_start,setDateRange_start] = React.useState<any>(null);
	const [dateRange_end,setDateRange_end] = React.useState<any>(null);
	const [parentOpportunityData,setparentOpportunityData] = React.useState<any>([]);
	const [levelsData,setLevelsData] = React.useState<any>([]);
	const [refreshchildOppData,setRefreshchildOppData] = React.useState<boolean>(false);
	const [allchartData, setAllChartData] = React.useState<any[]>([]);
	const [loading, setLoading] = React.useState<boolean>(false);
	const role= getUserRole(getUserAccessData()?.roleAccessMap)||"";

	const [searchText, setSearchText] = React.useState('');
	const [searchedColumn, setSearchedColumn] = React.useState('');
	const searchInput = React.useRef<InputRef>(null);

	const [pageNo, setPageNo] = React.useState<number>(0);
	const [pageSize, setPageSize] = React.useState<number>(10);
	const [totalCount, setTotalCount] = React.useState<number>(0);
	const [filters, setFilters] = React.useState<any>([]);


	const handleTableChange = (pagination: TablePaginationConfig,filters:any) => {
			const { current, pageSize } = pagination;
			const _current = current ? current - 1 : 0;
			setPageNo(_current);
			setPageSize(pageSize || 10);
			const _filters:any[] =[];
			 Object.keys(filters).map((key) => {
			  if(filters[key] && filters[key]!==undefined ){
	
				if(key==="opportunityID"){
				  _filters.push({field:key,value:filters[key][0],operator:'EQUALS'});
				}
				else{
				  _filters.push({field:key,value:filters[key][0],operator:'LIKE'});
				}
				
			  }
			})
			setFilters(_filters);
			dispatch(fetchOBOReport_AllOpportunities({
			'payload':{'clientName':selectedClient,
				'buName':getSelectedBu(selectedBu),
				'startDate':dateRange_start,
				'endDate':dateRange_end,
				'page':_current,
				'size':pageSize,
				"filters":_filters
			}
			})).then((res:any) => {
			if(res.type!=="oboReports/fetchOBOReport_AllOpportunities/fulfilled"){
				rejectedApiMessage(res.payload);
				setLoading(false);
			}
			else{
				
				let _temp = addkeytoData(res.payload.content);
				setparentOpportunityData(_temp);
				setTotalCount(res.payload?.totalElements);
           		setPageNo(_current);
				setLoading(false);
			}

		}
		);
	};


	  const handleSearch = (
		selectedKeys: string[],
		confirm: (param?: FilterConfirmProps) => void,
		dataIndex: DataIndex,
	  ) => {
		confirm();
		setSearchText(selectedKeys[0]);
		setSearchedColumn(dataIndex);
	  };
	  
	  const handleReset = (clearFilters: () => void) => {
		clearFilters();
		setSearchText('');
	  };
	  const getColumnSearchProps = (dataIndex: DataIndex): ColumnType<any> => ({
		filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
		  <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
		  <Input
		  ref={searchInput}
		  placeholder={`Search ${dataIndex}`}
		  value={selectedKeys[0]}
		  onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
		  onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
		  style={{ marginBottom: 8, display: 'block' }}
		  />
		  <Space>
		  <Button
		  type="primary"
		  onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
		  icon={<SearchOutlined />}
		  size="small"
		  style={{ width: 90 }}
		  >
		  Search
		  </Button>
		  <Button
		  onClick={() => {
			setSelectedKeys([]);
			handleSearch([], confirm, dataIndex);
		  }}
		  size="small"
		  style={{ width: 90 }}
		  >
		  Reset
		  </Button>
		  </Space>
		  </div>
		),
		filterIcon: (filtered: boolean) => (
		  <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
		),
		onFilter: (value, record) =>
		  record[dataIndex] && record[dataIndex]
		.toString()
		.toLowerCase()
		.includes((value as string).toLowerCase()),
		onFilterDropdownOpenChange: (visible) => {
		  if (visible) {
			setTimeout(() => searchInput.current?.select(), 100);
		  }
		},
		render: (text) =>
		  searchedColumn === dataIndex ? (
		  <Highlighter
		  highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
		  searchWords={[searchText]}
		  autoEscape
		  textToHighlight={text ? text.toString() : ''}
		  />
		) : (
		  text
		),
	  });

	  useEffect(() => {
		if(clientList.length===0 || buList.length===0){
		  dispatch(fetchBuAndClientDetails_OBO()).then((res: any) => {
			if (res.type === 'orderDashboard/fetchBuAndClientDetails_OBO/fulfilled') {
			  setBuList(res.payload?.buList?res.payload?.buList:[]);
			  setClientList(res.payload?.clientList?res.payload?.clientList:[]);
			  
			}else{
			  rejectedApiMessage(res.payload);
			} 
		  });
		}
		
		
		
	  }, [])
    const getclientlistdata_selectedclient_List_atstartingpositions_without_duplication = (clientList:any,selectedClient:any) => {
        let tempClientList = [...clientList];
        let tempSelectedClient = [...selectedClient];
        let tempClientList1 = [];
        tempClientList1 = tempClientList.filter((item:any) => {
          return !tempSelectedClient.includes(item);
        });
        return [...tempSelectedClient,...tempClientList1];
      }

	const viewOBOModal = (record:any,levelData:any) => {
		setoboModalVisible(true);
		setSelectedOpp(record);
		if(levelData.length>0){
			setLevelsData(levelData);
		}
		}

	const columns : TableColumnsType<DataType> = [
		{
			title:'',
			dataIndex:'key',
			key:'key',
			width:'5px',
			fixed: 'left',
			onCell: (record : any, rowIndex:any) => {
				return {
				  style: {
					borderLeft: rowIndex % 2 === 0 ? '4px solid #E30773' : '4px solid #034EA2',
					// backgroundColor: "#034EA2 !important;",
					// color: "#FFFFFF !important;",
				  }
				}
			  },
			render: (text: any, record: any) => {
				return(
				  <span></span>
				)
			}
		},
		Table.EXPAND_COLUMN,
		{
		  title: 'Client Name',
		  dataIndex: 'client',
		  key: 'client',
		  width: '150px',
		//   fixed: 'left',
		  
		  render(value, record, index) {
			return(
			  <span style= {{borderLeft: "5px solid #034EA2 !important;"}}>{value}</span>
			)
		  },
		  ...getColumnSearchProps('client'),
		},
		{
		  title: 'Opportunity ID',
		  dataIndex: 'opportunityID',
		  key: 'opportunityID',
		  width: '150px',
		//   fixed: 'left',
		  ...getColumnSearchProps('opportunityID'),
		},
		{
		  title: 'Opportunity Name',
		  dataIndex: 'opportunityName',
		  key: 'opportunityName',
		  width: '150px',
		  render: (text: any, record: any) => {
			return(
				<span style={{ wordBreak: 'break-word' }}>
				{text}
			  </span>
			)
		},
		  ...getColumnSearchProps('opportunityName'),
		},
		{
		  title: 'Contract Value',
		  dataIndex: 'sumOfTCV',
		  key: 'sumOfTCV',
		  width: '150px',
		  render: (text: any, record: any) => {
			return(
			  <span>{`$${formatNumberWithCommas( formatToTwoDecimalPlaces(text))}`}</span>
			)
		  }
		},
		{
		  title: 'Revenue For Period',
		  dataIndex: 'revenue',
		  key: 'revenue',
		  width: '150px',
		  render: (text: any, record: any) => {
			return(
			  <span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
			)
		  }
		},
		{
			title: 'Total Revenue',
			dataIndex: 'totalRevenue',
			key: 'totalRevenue',
			width: '150px',
			render: (text: any, record: any) => {
			  return(
				<span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
			  )
			}
		  },
		{
		  title: 'OBO Value',
		  dataIndex: 'obo',
		  key: 'obo',
		  width: '150px',
		  render: (text: any, record: any) => {
			return(
			  <span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
			)
		  }
		},
		{
		  title: 'Action',
		  dataIndex: 'action',
		  key: 'action',
		  fixed: 'right',
		  width: '100px',
		  render: (text:any, record: any, rowIndex :any ) => {
			return(
				<>
				{
					record.countOfChildOpp>0 &&
					// <span  className = { rowIndex % 2 === 0 ? 'opps-button-odd' : 'opps-button-even'} style={{padding:'4px 15px'}} >{record.countOfChildOpp} Opps</span>
					<Button type='link' className = { rowIndex % 2 === 0 ? 'opps-button-odd' : 'opps-button-even'}  style={{marginTop:record.countOfChildOpp>0?'10px':'inherit', cursor: 'unset'}} onClick={()=>{}}>{record.countOfChildOpp} Opps</Button>
				}
				{/* {
					record.opportunityID =="0063y000017vNbuAAE" &&
					<span  className = { rowIndex % 2 === 0 ? 'opps-button-odd' : 'opps-button-even'} style={{padding:'5px 5px'}} >{record.countOfChildOpp} Opps</span>

				} */}
				{
					record.countOfSow > 0 && 
					<Button type='link' className = { rowIndex % 2 === 0 ? 'opps-button-odd' : 'opps-button-even'} style={{marginTop:record.countOfChildOpp>0?'10px':'inherit'}} onClick={()=>viewOBOModal(record,[{'levelName':"ParentOpps",'levelData':record}])}>{record.countOfSow} SOWs</Button>
				}
				</>
			//   <Button type='link' className='opps-button' onClick={()=>viewOBOModal(record)}>12 OPPs</Button>
			)
		  }
		},
	  ];

	  const handleSelectAll = () => {
		setSelectedClient(clientList);
	  }
	  const handleSelectAll_BU = () => {
		setSelectedBu(buList);
	  }

	const getKeyValueForBU=(selectedBuValueList:any[])=>{
		let tempSelectedBuList :any[] = [];
		selectedBuValueList.map((item:any) => {
			let temp = buList.filter((bu:any) => bu.value===item);
			if(temp.length>0){
			tempSelectedBuList.push(...temp);
			}
			
		});
		return tempSelectedBuList;
	}  
	const handleChangedValue = (field:string,value:any) => {
		
		if(field==='client'){
		setSelectedClient(value);
		}else if(field==='bu'){    
		setSelectedBu(getKeyValueForBU(value));
		}
		else if(field==='dateRange'){
			getstartDateandEndDate(value);
			
		}
		
	}

	const getstartDateandEndDate = (dateRange:any) => {
		if(dateRange[0]!="" && dateRange[1]!=""){
		let startDate = dateRange[0].split('-');
		let endDate = dateRange[1].split('-');
		let startDateFormatted = `${startDate[0]}-${startDate[1]}-01`;
		let endDateFormatted = moment(`${endDate[0]}-${endDate[1]}-01`).endOf('month').format('YYYY-MM-DD');
		// return [startDateFormatted,endDateFormatted];
		setDateRange_end(endDateFormatted);
		setDateRange_start(startDateFormatted);
		}
		else{
		setDateRange_start(null);
		setDateRange_end(null);
		}

	}

	const checkSearchDisabled = () => {
		if(selectedClient.length==0 || dateRange_start==null || dateRange_end==null){
			return true;
		}
		else{
			return false;
		}
	}
	const getSelectedBu = (selectedBu:any[]) => {
		let tempSelectedBuList = [];
		tempSelectedBuList = selectedBu.map((item:any) => {
		  return item.value;
		});
		return tempSelectedBuList;
	  }
	const getopportunityIds = (data:any) => {
		let tempOppIds:any[] = [];
		data.map((item:any) => {
			if(item.opportunityID){
				tempOppIds.push(item.opportunityID);
			}
		});
		return tempOppIds;
	}
	const fetchOBODashboardData = () => {
		// dispatch(fetchOBOReport_AllOpportunities({}));
		setLoading(true);
		dispatch(fetchOBOReport_AllOpportunities({
			'payload':{'clientName':selectedClient,
				'buName':getSelectedBu(selectedBu),
				'startDate':dateRange_start,'endDate':dateRange_end,
				'page':0,
				'size':pageSize,
				"filters":filters
			}
			})).then((res:any) => {
			if(res.type==="oboReports/fetchOBOReport_AllOpportunities/fulfilled"){
				if(res.payload.content?.length>0){
					// setOBOReportData(res.payload.data);
					let _temp = addkeytoData(res.payload.content);
					setTotalCount(res.payload?.totalElements);
					setparentOpportunityData(_temp);
					setSearchText('');
					setSearchedColumn('');
					
					console.log("parent opportunity list",getopportunityIds(_temp));
					dispatch(setOBOFilterData({
						'clientName':selectedClient,
						'buName':selectedBu,
						'startDate':dateRange_start,
						'endDate':dateRange_end
					}
					
						
					))
					setLoading(false);

					fetchChartData();
				}else
				{
					message.error("No data available.");
					setparentOpportunityData([]);
					setAllChartData([]);
					setLoading(false);
				}
			}
			else{
				rejectedApiMessage(res.payload);
				setLoading(false);
			}

		}
		);
	}

	const downloadOBOReport = () => {

			dispatch(getOboDownloadReport({
				'payload':{'clientName':selectedClient,
					'buName':getSelectedBu(selectedBu),
					'startDate':dateRange_start,'endDate':dateRange_end
				}
			})).then(
			  (response: any) => {
				debugger;
				if (response.type !== 'oboReports/getOboDownloadFile/fulfilled') {
				  rejectedApiMessage(response.payload);
				}
				else{
				  
				 notification.success({
									message: 'Success',
									description: 'The Data for the Selected Period will be mailed to you',
								});
				}
			  }
			);
	}

	const fetchChartData = () => {

		dispatch(fetchOBOReport_ChartData({
			'payload':{'clientName':selectedClient,
				'buName':getSelectedBu(selectedBu),
				'startDate':dateRange_start,'endDate':dateRange_end
			}})).then((res: any) => {
					if (res.type === 'oboReports/fetchOBOReport_ChartData/fulfilled') {
						if(res.payload?.length > 0) {
							setAllChartData(res.payload||[]);
							// setAllChartData(_tempSample);
						}
						else{
							message.error("No data available.");
						}
					}else{
					  rejectedApiMessage(res.payload);
					} 
				  });
	}

	const addkeytoData = (data:any) => {
		let tempData = [...data];
		tempData.map((item:any,index:number) => {
			item.key = index+1;
		});
		return tempData;
	}

	const openSOWFromChild = (record:any, level:any) => {
		viewOBOModal(record,level);
	}
	const handleRefreshChildFlag = (flag:boolean) => {
		setRefreshchildOppData(flag);
	}
    return (
		<Spin spinning={oboReportData.loading || orderDashboardData.loading}>
        <div className='containerrr' style={{marginLeft:'10px', marginRight:'10px' }}>

        <div className='row'>
            <h2 className='col-lg-6 col-sm-12 page-heading'>
        	OPEN BOOK ORDER DASHBOARD
            </h2>
        </div>

        <div className='row'>
            <div className='col-lg-3'>
            	<div className='custom-fieldcolumn' 
								style={{marginLeft:'10px'}}>
								<FloatLabel label="Client Name *" 
								value= {selectedClient}
								isMultiSelect={true}
								> 
								<Select
								autoClearSearchValue
								mode="multiple"
								size='middle'
								className='financialspoc-select'
								style={{ width: '100%',maxHeight:'100px', minHeight:'58px' ,borderRadius:'0px' }}
								optionFilterProp="children"
								value= {selectedClient.map((item:any) => ({ value: item, label: item }))}
								maxTagCount={'responsive'}
								
								onChange={(value:string)=>handleChangedValue('client',value)}
								filterOption={(input:any, option:any) =>
									option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
								}
								options={getclientlistdata_selectedclient_List_atstartingpositions_without_duplication(clientList,selectedClient).map((item:any) => ({ value: item, label: item }))}
								dropdownRender={menu => (
								<>
								<div style={{display:'flex', justifyContent:'space-around', margin:'5px'}}>
								<Link onClick={()=>handleSelectAll()} disabled={selectedClient.length===clientList.length} >Select All</Link>
								<Link onClick={()=>handleChangedValue('client',[])} disabled={selectedClient.length==0}>Clear All</Link>
								</div>
								{menu}
								</>
								)}
								>
								</Select>
								</FloatLabel>
							</div>
        		</div>
          	<div className='col-lg-3 col-sm-12'>

            <div 
							className=' custom-fieldcolumn'
							// style={{width:'35%'}}
							>
							<FloatLabel label="Business Unit" value={selectedBu} >
							<Select
							autoClearSearchValue
							mode="multiple"
							size='middle'
							className='financialspoc-select'
							style={{ width: '100%',maxHeight:'100px', minHeight:'58px' }}
							optionFilterProp="children"
							value= {selectedBu.map((item:any) => ({ value: item.value, label: item.label }))}
							maxTagCount={'responsive'}
							
							onClear={()=>setSelectedBu([])}
							onChange={(value:string)=>handleChangedValue('bu',value)}
							filterOption={(input:any, option:any) =>
								option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
							}
							options={getclientlistdata_selectedclient_List_atstartingpositions_without_duplication(buList,selectedBu).map((item:any) => ({ value: item.value, label: item.label }))}
							dropdownRender={menu => (
								<>
								<div style={{display:'flex', justifyContent:'space-around', margin:'5px'}}>
								<Link onClick={()=>handleSelectAll_BU()} disabled={selectedBu.length===buList.length} >Select All</Link>
								<Link onClick={()=>handleChangedValue('bu',[])} disabled={selectedBu.length==0}>Clear All</Link>
								</div>
								{menu}
								</>
							)}
							>
							</Select> 
							</FloatLabel>
						</div>
					</div>

            <div className='col-lg-3 col-sm-12'>
              <FloatLabel label="Date Range *" value='das'>
              <RangePicker
              style={{width:'90%', height:'58px', borderRadius:'5px', paddingTop:'15px'}}
              format='YYYY-MM'
              picker='month' 
			  
            //   placeholder={['Start Month', 'End Month']}
			  onChange={(date, dateString) => handleChangedValue("dateRange",dateString)}
			  disabledDate={(current) => current && (current > moment().endOf('month') || current<moment('2024-04-13').startOf('month')) }
              />
              </FloatLabel>
                
                </div>
            <div className='col-lg-3 col-sm-12' style={{display:'flex', justifyContent:'flex-end',alignItems:'center'}}>
              <CustomButton label='SEARCH' width='90px'  disabled={checkSearchDisabled()}  type='submit' onClick={()=>fetchOBODashboardData()} />
                
                </div>
        </div>
		{allchartData.length>0 && <OboChartsContainer allChartData={allchartData}/>}
	  { allchartData.length>0 && <div className='row-header' >
		<div><span className='header-obo-opportunity'> Opportunity Details</span></div>
		{/* Export Button */}
		<Link style={{marginLeft:'auto', marginRight:'10px'}} onClick={()=>downloadOBOReport()}>
		<img src ={exportButton} alt='export' 
		/>
		</Link>
		</div>}
	  {allchartData.length>0  && !loading && <div className='roww'> 
		<Table 
		 className='table-styles'
		 columns={columns} 
		 showHeader={true}
		 
		 expandable={{
			expandedRowRender: (record:any, index:number, indent:number, expanded: boolean ) => <div 
			style={{borderLeft: index % 2 === 0?'4px solid #E30773' : '4px solid #034EA2',
				paddingLeft:'-16px'
			}}
			 ><OboChildOppDetailsTableContainer parentOpp={record} openSOWFromChild={openSOWFromChild} refreshchildData={handleRefreshChildFlag} ischildDataRefresh= {expanded}/></div>,
			rowExpandable: (record:any) => record.countOfChildOpp > 0,
			// rowExpandable: (record:any) => record.opportunityID =="0063y000017vNbuAAE",
			onExpand: (expanded, record) => {
				console.log("inside expand",expanded,record);
				if(expanded){
					setRefreshchildOppData(true);
				}
				
			},
			expandIcon: ({ expanded, onExpand, record }) => {
				return(
					<>
					{
						record.countOfChildOpp >0 ? expanded ? (
					<DownOutlined onClick={e => onExpand(record, e)} />
					) : (
					<RightOutlined  onClick={e => onExpand(record, e)} />
					) :
					<></>
					}
					</>
				)
			
			  
			}

			// expandIcon: ({ expanded, onExpand, record }) => {
			// 	return(
			// 		<>
			// 		{
			// 			record.opportunityID =="0063y000017vNbuAAE" ? expanded ? (
			// 		<DownOutlined onClick={e => onExpand(record, e)} />
			// 		) : (
			// 		<RightOutlined  onClick={e => onExpand(record, e)} />
			// 		) :
			// 		<></>
			// 		}
			// 		</>
			// 	)
			
			  
			// }
		}}
		
			dataSource={parentOpportunityData}
		 	scroll={{ x: 'max-content'}}
		 	pagination={{
				current: pageNo + 1,
				pageSize,
				total: totalCount,
				showSizeChanger: false,
			}}
			onChange={handleTableChange}
		/>
	  </div>}
		<OboModalContainer
			visible={oboModalVisible}
			onClose={() => setoboModalVisible(false)}
			data={selectedopp}
			level={levelsData}
			filterData={{
				'clientName':selectedClient,
				'buName':selectedBu,
				'startDate':dateRange_start,
				'endDate':dateRange_end
			}}
		/>
      </div>
	  </Spin>
    );
}
export default OboDashboard;